export default __webpack_public_path__ + "static/media/producto-05.8d060281.jpg";